import { useMemo } from 'react';
import { CheckIcon } from './Icons.jsx';
import CorrectnessTally from './CorrectnessTally.jsx';
import './OrderQuestion.css';

function shuffledIndices(n) {
  const arr = [...Array(n).keys()];
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  if (arr.every((v, i) => v === i) && n > 1) {
    [arr[0], arr[1]] = [arr[1], arr[0]];
  }
  return arr;
}

/**
 * Teacher/projector view for an order question. Each student gets their own
 * shuffle, so there's no single "student view" to mirror exactly — instead
 * this shows the same steps in one shared (shuffled, non-answer) order as a
 * reference while everyone arranges their own copy. On reveal, shows the
 * real correct sequence, numbered.
 */
export default function HostOrderPreview({ payload, revealed, tally, questionId }) {
  const previewOrder = useMemo(
    () => shuffledIndices(payload.cards.length),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [questionId]
  );

  if (revealed) {
    const correctOrder = Array.isArray(payload.correctOrder)
      ? payload.correctOrder
      : payload.cards.map((_, i) => i);
    return (
      <div className="stack">
        <ol className="order-list host-order-list">
          {correctOrder.map((cardIndex, pos) => (
            <li key={cardIndex} className="order-card host-order-card is-correct-final">
              <span className="order-index">{pos + 1}</span>
              <span className="order-text">{payload.cards[cardIndex]}</span>
              <CheckIcon size={18} className="host-order-check" />
            </li>
          ))}
        </ol>
        <CorrectnessTally tally={tally} />
      </div>
    );
  }

  return (
    <div className="stack">
      <ol className="order-list host-order-list">
        {previewOrder.map((cardIndex) => (
          <li key={cardIndex} className="order-card host-order-card is-preview">
            <span className="order-text">{payload.cards[cardIndex]}</span>
          </li>
        ))}
      </ol>
      <p className="host-preview-caption text-dim text-center">
        ผู้เรียนกำลังเรียงลำดับขั้นตอนเหล่านี้บนอุปกรณ์ของตนเอง (ลำดับด้านบนสลับไว้แล้ว ไม่ใช่คำตอบ)
      </p>
    </div>
  );
}
